import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: 'Personal Banking', path: '/' },
  { label: 'New User Registration', path: '/signup' },
  { label: 'Account Summary', path: '/account' },
];

function BankLayout({ children, pageTitle, strapline }) {
  const location = useLocation();

  return (
    <div style={styles.page}>
      <header style={styles.topBand}>
        <div style={styles.topInner}>
          <div style={styles.brandRow}>
            <div style={styles.logoMark}>Y</div>
            <div>
              <div style={styles.brandName}>Load Bank</div>
              <div style={styles.brandSub}>Digital Banking Demo</div>
            </div>
          </div>

          <div style={styles.topMeta}>
            <span>Load Bank secure banking starts with protected credentials.</span>
            <span style={styles.metaDivider}>|</span>
            <span>24x7 Digital Access</span>
          </div>
        </div>
      </header>

      <nav style={styles.navbar}>
        <div style={styles.navInner}>
          {navItems.map(item => {
            const active =
              location.pathname === item.path ||
              (item.path === '/' && location.pathname === '/');

            return (
              <Link
                key={item.label}
                to={item.path}
                style={{
                  ...styles.navLink,
                  ...(active ? styles.navLinkActive : {}),
                }}
              >
                {item.label}
              </Link>
            );
          })}
        </div>
      </nav>

      <div style={styles.banner}>
        <div>
          <div style={styles.bannerTitle}>{pageTitle}</div>
          <div style={styles.bannerText}>{strapline}</div>
        </div>
        <div style={styles.bannerBadge}>Load Bank online banking</div>
      </div>

      <main style={styles.main}>{children}</main>
    </div>
  );
}

const styles = {
  page: {
    minHeight: '100vh',
  },
  topBand: {
    background: 'linear-gradient(90deg, var(--sbi-deep-blue) 0%, var(--sbi-blue) 68%, #4672b8 100%)',
    color: '#fff',
    padding: '18px 20px 14px',
    boxShadow: '0 10px 24px rgba(15, 53, 113, 0.18)',
  },
  topInner: {
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    gap: 16,
    justifyContent: 'space-between',
    margin: '0 auto',
    maxWidth: 1180,
  },
  brandRow: {
    alignItems: 'center',
    display: 'flex',
    gap: 12,
  },
  logoMark: {
    alignItems: 'center',
    background: 'radial-gradient(circle at 35% 35%, #ffffff 0%, #d9e5fb 16%, #8eafe2 17%, #8eafe2 30%, #ffffff 31%, #ffffff 43%, #8eafe2 44%, #8eafe2 100%)',
    borderRadius: '50%',
    color: 'transparent',
    display: 'flex',
    fontWeight: 700,
    height: 46,
    justifyContent: 'center',
    width: 46,
  },
  brandName: {
    fontSize: 27,
    fontWeight: 700,
    letterSpacing: 0.3,
  },
  brandSub: {
    color: '#d6e4ff',
    fontSize: 13,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
  },
  topMeta: {
    color: '#d6e4ff',
    display: 'flex',
    flexWrap: 'wrap',
    fontSize: 13,
    gap: 8,
    justifyContent: 'flex-end',
  },
  metaDivider: {
    color: '#95b3ea',
  },
  navbar: {
    background: '#fff',
    borderBottom: '1px solid var(--sbi-border)',
  },
  navInner: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0 auto',
    maxWidth: 1180,
  },
  navLink: {
    borderRight: '1px solid #dde6f5',
    color: 'var(--sbi-deep-blue)',
    fontSize: 14,
    fontWeight: 700,
    padding: '14px 18px',
    textDecoration: 'none',
  },
  navLinkActive: {
    background: 'linear-gradient(180deg, #fefefe 0%, #edf3ff 100%)',
    boxShadow: 'inset 0 -3px 0 var(--sbi-gold)',
  },
  banner: {
    alignItems: 'center',
    background: 'linear-gradient(135deg, #f8fbff 0%, #eaf1fc 100%)',
    border: '1px solid #cad7ee',
    borderRadius: 16,
    display: 'flex',
    flexWrap: 'wrap',
    gap: 16,
    justifyContent: 'space-between',
    margin: '24px auto 0',
    maxWidth: 1180,
    padding: '18px 22px',
    width: 'calc(100% - 32px)',
  },
  bannerTitle: {
    color: 'var(--sbi-deep-blue)',
    fontSize: 28,
    fontWeight: 700,
  },
  bannerText: {
    color: 'var(--sbi-muted)',
    fontSize: 15,
    marginTop: 4,
  },
  bannerBadge: {
    background: '#fff',
    border: '1px solid #d6e0f2',
    borderRadius: 999,
    color: 'var(--sbi-blue)',
    fontSize: 12,
    fontWeight: 700,
    letterSpacing: 0.3,
    padding: '10px 14px',
    textAlign: 'center',
    textTransform: 'uppercase',
  },
  main: {
    margin: '20px auto 32px',
    maxWidth: 1180,
    width: 'calc(100% - 32px)',
  },
};

export default BankLayout;
